import styled, { css } from 'styled-components';
import curry from 'lodash/curry';

import { makeButtonCSS, makeVariantTheme } from '../../Button/StyledButton';
import { cssDeclaration, VALID_DIMENSION_DATA } from '../../Utils';
import { SVGIconStyleWrapper } from '../../../Icon/SVGIcon';

import { IFileUploadInputLabelProps } from './FileUpload.type';

export const FileUploadInputLabel = styled.label<IFileUploadInputLabelProps>`
  cursor: pointer;
  display: block;

  ${({ theme: { themeTwo: theme }, alignSelf, flexShrink, variant, widthProp, marginProp, orderProp, flexBasis, flexGrow }) => {
    const buildCSS = curry(makeButtonCSS)(theme);
    const variantTheme = makeVariantTheme(theme, variant).variantTheme;
    const themeBase = buildCSS(variantTheme);

    return css`
      ${themeBase}
      /* width */
      ${widthProp && cssDeclaration(theme, 'width', widthProp)};
      /* margin */
      ${marginProp && cssDeclaration(theme, 'margin', marginProp)};
      /* align-self */
      ${alignSelf && cssDeclaration(theme, 'align-self', alignSelf)};
      /* flex-basis */
      ${flexBasis && cssDeclaration(theme, 'flex-basis', flexBasis)};
      /* flex-grow */
      ${flexGrow && cssDeclaration(theme, 'flex-grow', flexGrow)};
      /* flex-shrink */
      ${flexShrink && cssDeclaration(theme, 'flex-shrink', flexShrink)};
      /* order */
      ${orderProp && cssDeclaration(theme, 'order', orderProp)};

      & > span {
        display: flex;
        justify-content: center;
        align-items: center;
      }

      & > span > ${SVGIconStyleWrapper} {
        display: flex;
      }
    `;
  }}
`;

export const FileUploadInput = styled.input<{ variant: string; widthProp?: VALID_DIMENSION_DATA }>`
  ${({ theme: { themeTwo: theme }, variant, widthProp }) => {
    const buildCSS = curry(makeButtonCSS)(theme);
    const themeObj = makeVariantTheme(theme, variant);
    const active = buildCSS(themeObj.variantActiveTheme);
    const hover = buildCSS(themeObj.variantHoverTheme);
    const focus = buildCSS(themeObj.variantFocusTheme);
    const disabled = buildCSS(themeObj.variantDisabledTheme);
    const widthOverride = widthProp ? cssDeclaration(theme, 'width', widthProp) : undefined;

    return css`
      &:hover + ${FileUploadInputLabel} {
        ${hover}
        ${widthOverride}
      }

      &:focus + ${FileUploadInputLabel} {
        ${focus}
        ${widthOverride}
      }

      &:active + ${FileUploadInputLabel} {
        ${active}
        ${widthOverride}
      }

      &:disabled + ${FileUploadInputLabel} {
        ${disabled};
        cursor: not-allowed;
        ${widthOverride}
      }
    `;
  }}
`;
